module.exports = __webpack_public_path__ + "static/Net-Iphone-22d8d42ec819920b6634df27f0c7ce93.mp4";